import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children, allowedRoutes }) => {
  const location = useLocation();
  const lowerCaseAllowedRoutes = allowedRoutes.map((route) => route.toLowerCase());

  if (!lowerCaseAllowedRoutes.some(route =>
    route.includes(":")
      ? location.pathname.toLowerCase().startsWith(route.split(":")[0])
      : route === location.pathname.toLowerCase()
  )) {
    console.log("Unauthorized access to route:", location.pathname);
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default PrivateRoute;